// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-1d6w6","name":"name-3X3Fa","item":"item-2OwkB","button":"button-TSUaH"};